// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"229":"50be69f31d27fedc","395":"24b6d28cbe8855ad","405":"50be69f31d27fedc","888":"821fd60320600fe9"}[chunkId] + ".css";
};